export default __webpack_public_path__ + "static/media/vue.5fd4443c.png";